import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "#8a8f98", strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("polyline", { points: "6 9 12 15 18 9" }));
const ForwardRef = forwardRef(SvgDownArrow);
export default ForwardRef;
